import React from 'react'
import { Button, Modal } from 'antd'
import './ModalAuthUuid.css'
import { nbsp, mdash } from '../../../Constants'

const KUPER_LINK = 'https://kuper.ru/rabota'

function ModalAuthUuid ({ isModalOpen, onOk, isGermesError = false }) {
  const handleOk = () => onOk?.()

  return (
    <Modal
      className='modalAuthUuid'
      visible={isModalOpen}
      footer={null}
      closable={false}
      centered
    >
      <div className='header'>Номер не найден</div>
      <div className='message'>
        {!isGermesError ? (
          <>
            Укажите номер, с которого оставляли отклик. Если к нему нет доступа или хотите указать
            другой{nbsp}{mdash} сообщите наставнику
          </>
        ) : (
          <>
            Не нашли ваш номер телефона. Проверьте корректность данных или зарегистрируйтесь <a href={KUPER_LINK} target='_blank' rel='noreferrer'>на сайте</a>, чтобы начать сотрудничество.
            Если возникнут сложности, звоните: <br />8 800 250 54 50
          </>
        )}
      </div>
      <div className='footer'>
        <Button
          block
          size='large'
          type='primary'
          onClick={handleOk}
        >
          Понятно
        </Button>
      </div>
    </Modal>
  )
}

export default ModalAuthUuid
